import { render, staticRenderFns } from "./chart-card.vue?vue&type=template&id=bba25ee8&scoped=true&"
import script from "./chart-card.vue?vue&type=script&lang=ts&"
export * from "./chart-card.vue?vue&type=script&lang=ts&"
import style0 from "./chart-card.vue?vue&type=style&index=0&id=bba25ee8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba25ee8",
  null
  
)

export default component.exports